import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class TraderOfferGroup extends Cloneable {

    static _values = [
        new TraderOfferGroup(0, "OTHER"),
        new TraderOfferGroup(1, "PETS"),
        new TraderOfferGroup(2, "PETS_CHEAP"),
    ];

    static getValues() {
        return TraderOfferGroup._values;
    }

    static getValue(id) {
        let value = TraderOfferGroup._values.find(v => v.id === id) || null;
        console.assert(value, "unknown value: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TraderOfferGroup.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof TraderOfferGroup) {
            return TraderOfferGroup._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof TraderOfferGroup) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TraderOfferGroup());
        } else if (target instanceof TraderOfferGroup) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TraderOfferGroup, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});